<template>
    <div class="alert alert-success" role="alert" v-if="message">
        {{ message }}
    </div>
    <form class="form-group" @submit.prevent="updatePassword">
        <div class="form-group">
            <input 
                id="email" 
                type="email" 
                class="col-md-12 col-form-label" 
                :class="{'has-error': updateForm.errors.has('email')}"
                name="email" 
                v-model="updateForm.email"
                required 
                autocomplete="email" 
                autofocus 
                :pattern="email_pattern"
                :placeholder="$t('login.email')">

            <span class="fa fa-envelope form-control-feedback symbol-input"></span>
            <HasError :form="updateForm" field="email"></HasError>
        </div>

        <div class="form-group">
            <input id="password" 
                   type="password" 
                   class="col-md-12 col-form-label" 
                   :class="{'has-error': updateForm.errors.has('password')}"
                   name="password" 
                   v-model="updateForm.password"
                   required 
                   autocomplete="new-password" 
                   :placeholder="$t('login.password')">

            <span class="fa fa-lock form-control-feedback symbol-input"></span>
            <HasError :form="updateForm" field="password"></HasError>
        </div>

        <div class="form-group">
            <input id="password-confirm" type="password" 
                   class="col-md-12 col-form-label" 
                   :class="{'has-error': updateForm.errors.has('password_confirmation')}"
                   name="password_confirmation"  
                   v-model="updateForm.password_confirmation"
                   required 
                   autocomplete="new-password" 
                   :placeholder="$t('register.password_confirm')">

            <span class="fa fa-lock form-control-feedback symbol-input"></span>
            <HasError :form="updateForm" field="password_confirmation"></HasError>
        </div>

        <div class="form-group row mb-0">
            <div class="col col-12 ">
                <button type="submit" class="btn btn-primary btn-block text-center slide-btn">
                    {{ $t('password.reset_submit_button') }}
                </button>
            </div>
        </div>
    </form>
    <div class="text-center w-full">
        <p>
            <router-link :to="{name: 'login'}" class="txt1">
                <i class="fa fa-long-arrow-left"></i>&nbsp;{{ $t('login.sign_in2') }}
            </router-link>
        </p>
    </div>
</template>
<script>
    import _ from 'lodash';
    export default {
        name: 'PasswordUpdateForm',
        data() {
            return {
                updateForm: new Form({
                    email: '',
                    password: '',
                    password_confirmation: '',
                    token: ''
                }),
                message: ''
            };
        }
        , components:{
            
        }
        , created() {
            this.updateForm.email = this.email;
        }
        , computed:{
            token(){
                return this.$route.params.token;
            },
            email(){
                return this.$route.query.email;
            }
        }
        , mounted() {
//            console.log('Register.vue');
        }
        , methods: {
            updatePassword(){
                let url = '/password/reset';
                
                this.updateForm.lang = window.langKey;
                this.updateForm.token = this.token;
                this.updateForm.post(url)
                .then(response => {
                    if(response.status === 200){
                        this.message = response.data.message;
                        this.redirectToLogin(this);
                    }
                }).catch(function (error) {

                });
            },
            redirectToLogin: _.debounce((vueJs) => {
               vueJs.$router.push({ name: 'login'});
            }, 2000)
        }
    }
</script>